import { action, makeObservable, observable } from 'mobx';

import { AuthCustomer } from '../../typings/telia-sso-client';
import ApiService from '../services/ApiService';

import { Loadable } from './models/Loadable';
import { PaymentHistory } from './models/PaymentHistory';
import { Transaction } from './models/Transaction';
import { TransactionFilter } from './models/TransactionFilter';

export interface ITransactionStore {
  readonly transactions: Loadable<Transaction[]>;
  readonly openingBalance: number;
  readonly closingBalance: number;
  readonly totalInvoiceAmount: number;
  readonly totalReceiptAmount: number;

  loadTransactions(customer: AuthCustomer, transactionFilter?: TransactionFilter): void;
}

export default class TransactionStore implements ITransactionStore {
  @observable
  public transactions: Loadable<Transaction[]> = new Loadable<Transaction[]>();
  @observable
  public openingBalance = 0;
  @observable
  public closingBalance = 0;
  @observable
  public totalInvoiceAmount = 0;
  @observable
  public totalReceiptAmount = 0;

  constructor(private apiService: ApiService) {
    makeObservable(this);
  }

  @action.bound
  public loadTransactions(customer: AuthCustomer, paymentHistoryFilter?: TransactionFilter): void {
    const transform = (paymentHistory) => {
      this.initTransactions(paymentHistory);
      return paymentHistory.transactions;
    };
    this.transactions = Loadable.toLoadable<PaymentHistory, Transaction[]>(
      this.apiService.getPaymentHistory(customer.customerId, paymentHistoryFilter),
      transform.bind(this)
    );
  }

  @action.bound
  private initTransactions(paymentHistory: PaymentHistory): void {
    this.openingBalance = paymentHistory.openingBalance;
    this.closingBalance = paymentHistory.closingBalance;
    this.totalInvoiceAmount = paymentHistory.totalInvoiceAmount ? paymentHistory.totalInvoiceAmount : 0;
    this.totalReceiptAmount = paymentHistory.totalReceiptAmount ? paymentHistory.totalReceiptAmount : 0;
  }
}
